import type { ThemeOptions } from '@mui/material';

const Tooltip: ThemeOptions['components'] = {
  MuiTooltip: {
    defaultProps: {
      arrow: true,
    },
    styleOverrides: {
    },
  },
};

export default Tooltip;
